import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '@app/store/shared/models';

export const sessionActions = createActionGroup({
    source: 'Session',
    events: {
        'Get Session': emptyProps(),
        'Get Session Success': props<{ payload: User }>(),
        'Get Session Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
